import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { postAddAccount } from "../../../CommonURL";
import { postDataWithToken } from "../../../Utils/restUtils";
import { AddTax, DiscriptionText,  Name, NameError, CurrencyCode,BankNameText,BankNo,BankAddress, SubmitForm, AccountNo, OpeningBalance, BankNoError, BankNameError, AccountNoError, BankAddressError, CurrencyCodeError, OpeningBalanceError, AddAccount } from '../../../Constant';
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const AccountAddContainer = () => {
    const schema = yup.object().shape({
  name: yup
    .string()
    .required(NameError)
    .min(3, "Minimum 3 characters"),

  bankName: yup
    .string()
    .required(BankNameError),

  bankNo: yup
    .string()
    .required(BankNoError)
    .matches(/^[0-9]{10,15}$/, "Enter valid phone number"),

  bankAddress: yup
    .string()
    .required(BankAddressError),

  accountNo: yup
    .string()
    .required(AccountNoError)
    .matches(/^[0-9]+$/, "Only numbers allowed"),

  openingBalance: yup
    .number()
    .typeError("Enter valid amount")
    .required(OpeningBalanceError)
    .min(0, "Must be greater than 0"),

  currencyCode: yup
    .string()
    .required(CurrencyCodeError),
});
    const { register, handleSubmit, control, formState: { errors } } = useForm({resolver: yupResolver(schema),});
    const [loading,setLoading]=useState(false);
    const navigate = useNavigate();

    const onSubmit = async (data) => {

        setLoading(true);
        const postRequest={name:data.name, opening_balance:data.openingBalance, country_code:data.currencyCode, bank_name:data.bankName, bank_phone:data.bankNo, bank_address:data.bankAddress, account_number:data.accountNo }
        const addTaxResponse = await postDataWithToken(postAddAccount, postRequest);
        if (addTaxResponse.data) {
            navigate(`${process.env.PUBLIC_URL}/configuration/account`);
        } else {
            // errors.showMessages();
            setLoading(false);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner/>
            )}
            
            <Breadcrumbs mainTitle='Add Account' parent="Configuration" title="Account" />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{AddAccount}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3">
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{Name} <span className="requireStar">*</span></Label>
                                <input className="form-control" placeholder="Name" {...register("name")} />
                                <span className="text-danger">{errors.name?.message}</span>

                            </Col>
                            <Col md="6">
                            <Label className="form-label" for="validationCustom02">{BankNameText} <span className="requireStar">*</span></Label>
                                <input className="form-control" placeholder="Bank Name" {...register("bankName")} />
                                <span className="text-danger">{errors.bankName?.message}</span>

                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{BankNo} <span className="requireStar">*</span></Label>
                              <input  className="form-control" placeholder="Bank Phone no" type="text"inputMode="numeric"onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}{...register("bankNo")}/>
                              <span className="text-danger">{errors.bankNo?.message}</span>

                            </Col>
                            <Col md="6">
                            <Label className="form-label" for="validationCustom02">{BankAddress} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="validationCustom02" type="text" placeholder="Bank Address" {...register('bankAddress',{ required: true })} />
                                <span className="text-danger">{errors.bankAddress && BankAddressError}</span>   
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{AccountNo} <span className="requireStar">*</span></Label>
                                <input className="form-control"  type="text"  inputMode="numeric" placeholder="Account No" onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}  {...register("accountNo")} />
                                <span className="text-danger">{errors.accountNo?.message}</span>

                            </Col>
                            <Col md="6">
                            <Label className="form-label" for="validationCustom02">{OpeningBalance} <span className="requireStar">*</span></Label>
                                <input className="form-control" type="number" placeholder="Opening Balance" {...register("openingBalance")} />
                                <span className="text-danger">{errors.openingBalance?.message}</span>
  
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="validationCustom01">{CurrencyCode} <span className="requireStar">*</span></Label>
                                <input className="form-control" placeholder="Currency Code" {...register("currencyCode")} />
                                <span className="text-danger">{errors.currencyCode?.message}</span>

                            </Col>
                        </Row>
                        {/* <Row className="g-3">
                            <Col>
                                <Label className="form-label pt-3">{DiscriptionText}</Label>
                                <Controller
                                    name="message"
                                    control={control}
                                    render={({ field }) => (
                                        <textarea
                                            className="form-control"
                                            {...field}
                                            rows="3" // Set the 'rows' attribute to 3 here
                                        />
                                    )}
                                />
                            </Col>
                        </Row> */}
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{SubmitForm}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default AccountAddContainer;